import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Spin, Tooltip, Icon, message } from 'antd';
import API_URL from '../../../../common/url';
import Fetch from '../../../../common/Fetch';
import $ from '../../../../common/AjaxRequest';
import moment from 'moment';
import { DefaultParams } from '../../constants/project';

function hasValue(value) {
    return value || value === 0;
}

class ColorBox extends PureComponent {
    static contextTypes = {
        activeKey: PropTypes.string,
        handleExpand: PropTypes.func
    }

    state = {
        data: {},
        loading: false,
    }

    componentDidMount() {
        if (this.props.params.statisticDate) {
            this.loadData();
        }

    }

    componentDidUpdate(prevProps) {
        if (prevProps.refresh !== this.props.refresh) {
            this.loadData();
        }
    }

    loadData = () => {
        const { activeKey } = this.context;
        const { moduleType, params } = this.props;
        const { areaParams,statisticDate,hasCheckedArea,statisticalRange,investigationMedicineType = [],...rest } = params;
        this.setState({ loading: true });
        Fetch.post(API_URL.dashboard.queryStatisticReportData, {
            moduleType,
            ...rest,
            ...areaParams,
            statisticDate,
            year:statisticDate?moment(statisticDate).format('YYYY'):null,
            statisticalRange:statisticalRange||(DefaultParams&&DefaultParams[activeKey]),
            investigationMedicineType: investigationMedicineType[0],
            secondResearchProductType: investigationMedicineType[1],
        }).then(res => {
            this.setState({
                loading: false,
                data: res.data||{}
            });
        });
    }

    handlePlanValueClick = (e) => {
        e.stopPropagation();
        const { userId } = sessionStorage;
        const { params } = this.props;
        const { statisticDate } = params;
        const month = statisticDate ? moment(statisticDate).format('YYYY-MM') : moment().format('YYYY-MM');
        const options = {
            method: 'POST',
            url: API_URL.monthlyPlan.checkPermission,
            data: { curUserId: userId },
            dataType: 'json',
            doneResult: (res) => {
                if (res.success && res.data && res.data.hasPermission) {
                    sessionStorage.setItem('_planMonth', month);
                    window.dispatchEvent(new CustomEvent('switchToMonthlyPlan'));
                } else {
                    message.warning(res.data ? res.data.message : '当前用户无权限查看年度/月度计划内容');
                }
            },
        };
        $.sendRequest(options);
    }

    getCompareDom = (type) => {
        const { reversal } = this.props;
        const { data } = this.state;
        const value = data[`${type}On${type.replace(/^\w/, m => m.toUpperCase())}Count`];
        let dom;
        if (value > 0) {
            dom = <Icon key="icon" style={{ color: reversal ? '#0F0' : '#F00', fontSize: "6px" }} type="caret-up" />;
        } else if (value < 0) {
            dom = <Icon key="icon" style={{ color: reversal ? '#F00' : '#0F0', fontSize: "6px" }} type="caret-down" />;
        } else if (!value || value === 0) {
            dom = <Icon key="icon" type="minus" />;
        };

        return [
            dom,
            <span key="value">{Math.abs(value || 0)}%</span>
        ];
    }

    render() {
        const { handleExpand, activeKey } = this.context;
        const { title, backgroundImage, showCompare, toType,params, moduleType } = this.props;
        const { loading, data } = this.state;
        const { mainCount, secondCount, firstNum, secondNum } = data;
        const canJumpToPlan = activeKey === 'scheduleVariance'
            && (moduleType === 'PA_VISIT_AMOUNT' || moduleType === 'PA_SITE_START');

        const renderPlanValue = (value) => {
            if (!hasValue(value)) return '－';
            return canJumpToPlan
                ? <span className="plan-value-clickable" onClick={this.handlePlanValueClick}>{value}</span>
                : value;
        };

        const renderColorData = () => {
            if (hasValue(firstNum) || hasValue(secondNum)) {
                return (
                    <span>
                        {hasValue(mainCount) ? <span>{mainCount.toFixed(2)}% </span> : '－'}({hasValue(firstNum) ? ` ${renderPlanValue(firstNum)}` : ''}{hasValue(secondNum) ? ` / ${secondNum}` : ''})
                    </span>
                );
            }
            return (
                <span>
                    {renderPlanValue(mainCount)}{hasValue(secondCount) ? ` / ${secondCount}` : ''}
                </span>
            );
        };

        return (
            <div className="colorBox" style={{ backgroundImage: `url(../../../../images/${backgroundImage}.png)` }}>
                <Spin spinning={loading}>
                    <Tooltip placement="top" title={title}>
                        <p className="colorTitle hidden">{title}</p>
                    </Tooltip>
                    <p className="colorData">
                        {renderColorData()}
                    </p>
                    {
                        showCompare &&
                        <div className="colorCompare">
                            <p>
                                <span>月环比</span>
                                {this.getCompareDom('month')}
                            </p>
                            <p>
                                <span>同&nbsp;&nbsp;&nbsp;&nbsp;比</span>
                                {this.getCompareDom('year')}
                            </p>
                        </div>
                    }
                </Spin>
                { toType && <div className="colorMore" onClick={() => handleExpand(toType,params)}>MORE</div>}
            </div>
        );
    }
}

export default ColorBox;



// WEBPACK FOOTER //
// ./src/components/homePage/projectIndicatorAnalysis/components/ColorBox.js